import { getStressAssessmentRole } from '@fukuri-admins/utils/common/cookies';
import clsx from 'clsx';
import { Navigate } from 'react-router-dom';
import { IS_STRESS_CHECK_IMPLEMENTER_BUILD } from '~/constants';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { StressAssessmentRoleSelect } from '~/features/StressAssessmentRoleSelect';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  const stressAssessmentRole = getStressAssessmentRole();

  if (stressAssessmentRole) {
    return <Navigate to={ROUTES.STRESS_ASSESSMENTS.INDEX} />;
  }

  return (
    <div
      className={clsx(styles.Screen, {
        [styles.NoSideMenu]: IS_STRESS_CHECK_IMPLEMENTER_BUILD,
      })}
    >
      {!IS_STRESS_CHECK_IMPLEMENTER_BUILD && <ClientSideMenu />}
      <StressAssessmentRoleSelect />
    </div>
  );
};
